import { lazy } from "react";

const routes = [
  {
    path: "/settings/locations",
    element: lazy(() => import("../../pages/Settings/Locations")),
  },
];

export default routes;
